import { Spinner } from "react-bootstrap";
import { useAxios } from "./AxiosContext"

import { createContext, ReactNode, useContext, useEffect, useState } from "react";

export type BankId = string

export interface BankDetails {
  name: string
  logoUrl: string
}

export const BankContext = createContext<Record<BankId, BankDetails> | undefined>(undefined);

interface BankProviderProps {
  children: ReactNode
}


export const BankProvider: React.FC<BankProviderProps> = ({ children }) => {
  const axios = useAxios()

  const [banks, setBanks] = useState<Record<BankId, BankDetails> | undefined>(undefined)

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const banksResponse = await axios.get(`/v1/banks`)

        setBanks(banksResponse.data.banks)
      } catch (error) {
        console.error("Error fetching banks", error)
      }
    }

    fetchBanks()
  }, [axios])

  return <BankContext.Provider value={banks}>{children}</BankContext.Provider>
}

export const useBanks = () => {
  const banks = useContext(BankContext)

  return banks
}

interface BankProps {
  id: BankId
}

export const Bank: React.FC<BankProps> = ({ id }) => {
  const banks = useBanks()

  if (banks) {
    const bank = banks[id]

    return (bank ? <span className="fw-semibold"><img src={bank.logoUrl} alt={bank.name} style={{width: "1em"}} />&nbsp;{bank.name}</span> : <>{id}</>)
  } else {
    return <Spinner animation="border" />
  }

}
